/**
 * Helper functions for API calls.
 */

/**
 * Create a Plato API URL starting from an endpoint name.
 *
 * @param endpoint {string} The API endpoint; the leading / or /v2 is removed.
 * @returns {`${string}/v2/${string}`}
 */
export const apiEndpoint = (endpoint = '') => {
  const host = process.env.REACT_APP_PLATO_API_URL;
  return `${host}/v2/${normalisePathComponent(endpoint)}`;
};

/**
 * Create a Plato API URL giving you full control of the path.
 *
 * @param path {string} The URL path component; the leading / is removed.
 * @returns {`${string}/${string}`}
 */
export const apiUrl = (path = '') => {
  const host = process.env.REACT_APP_PLATO_API_URL;
  return `${host}/${normalisePathComponent(path)}`;
};

export const isTest = () => {
  const envName = process.env.REACT_APP_ENV ?? '';
  return envName === 'development' || envName === 'testing';
};

/**
 * Trim the trailing / or /v2 prefix so the path can be concatenated to the rest of the URL.
 *
 * @param path {string}
 * @returns {string}
 */
const normalisePathComponent = (path = '') => path.replace(/^\/?(?:v2(?:\/|$))?/, '');
